<footer>
  <div class="main">Visit us at one of our 3 great locations</div>
  <div class="main">
    <div class="store"><div>Penn Hills</div><div><a href="tel:412-793-4020">412-793-4020</a></div></div>
    <div class="store"><div>Lower Burrell</div><div><a href="tel:724-339-0120">724-339-0120</a></div></div>
    <div class="store"><div>Bloomfield</div><div><a href="tel:412-621-2511">412-621-2511</a></div></div>
  </div>
</footer>
